import { TFunction } from 'i18next'

import {
  DcaExecutionStatus,
  DcaOrderStatus,
  DcaPauseReason
} from '@web/extension-services/background/controllers/dca/types'

export const getOrderStatusText = (status: DcaOrderStatus, t: TFunction) => {
  switch (status) {
    case 'ACTIVE':
      return t('Active')
    case 'PAUSED':
      return t('Paused')
    case 'COMPLETED':
      return t('Completed')
    case 'EXPIRED':
      return t('Expired')
    case 'CANCELLED':
      return t('Cancelled')
    default:
      return status
  }
}

export const getPauseReasonText = (reason: DcaPauseReason | null, t: TFunction) => {
  switch (reason) {
    case 'INSUFFICIENT_ALLOWANCE':
      return t('Paused: the token approval was lowered or revoked')
    case 'EXECUTION_FAILURES':
      return t('Paused after repeated failed buys')
    default:
      return t('Paused by you')
  }
}

export const getExecutionStatusText = (status: DcaExecutionStatus, t: TFunction) => {
  switch (status) {
    case 'SUCCESS':
      return t('Bought')
    case 'SKIPPED':
      return t('Skipped')
    default:
      return t('Failed')
  }
}

/** DCA client doc §6.4; unknown codes get the generic sentence. */
export const getExecutionReasonText = (code: string | null, t: TFunction) => {
  switch (code) {
    case 'INSUFFICIENT_BALANCE':
      return t('Not enough balance at the time of the buy')
    case 'INSUFFICIENT_ALLOWANCE':
      return t('The token approval was too low')
    case 'ATTESTATION_REFUSED':
      return t('No safe price was available (low liquidity or unusual volatility)')
    case 'PRICE_CHECK_FAILED':
      return t('Skipped to protect you from an unusual price')
    case 'SIMULATION_FAILED':
      return t('The swap would have failed (slippage or liquidity)')
    case 'TX_REVERTED':
      return t('The transaction was reverted on-chain')
    case 'ATTESTATION_MISMATCH':
    case 'KEEPER_ERROR':
      return t('Temporary system error')
    default:
      return t('This buy could not be made')
  }
}
